import React from "react";
import "./volunteerTable.scss";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { Stack, Table } from "react-bootstrap";
import { t } from "i18next";
import { Link } from "react-router-dom";

const VolunteerTable = ({ data }) => {
  console.log(data);
  return (
    <div className="volunteer-table-container">
      <Stack gap={1}>
        <span className="title-volunteer-table">
          {t("dashboard.list_volunteer_and_member")}
        </span>
        <Table borderless className="volunteer-table">
          <thead>
            <tr>
              <th>{t("dashboard.table_field.name")}</th>
              <th>{t("dashboard.table_field.role")}</th>
              <th>{t("dashboard.table_field.phone")}</th>
              <th>{t("dashboard.table_field.email")}</th>
            </tr>
          </thead>
          <tbody>
            {data.slice(0, 4).map((item, index) => (
              <tr key={index}>
                <td className="d-flex align-items-center">
                  <Stack gap={1} direction="horizontal">
                    <img src={item.image} alt="img" />
                    <span>
                      {item.name} {item.surname}
                    </span>
                  </Stack>
                </td>
                <td>
                  {!item.admin && !item.member ? (
                    <span style={{ color: "#488339" }}>Volontario</span>
                  ) : (
                    ""
                  )}
                  {!item.admin && item.member ? (
                    <span style={{ color: "#7F0FE1" }}>Socio</span>
                  ) : (
                    ""
                  )}
                  {item.admin && !item.member ? (
                    <span style={{ color: "#C61111" }}>Amministratore</span>
                  ) : (
                    ""
                  )}
                  {item.admin && item.member ? (
                    <span style={{ color: "#C61111" }}>
                      Amministratore & Socio
                    </span>
                  ) : (
                    ""
                  )}
                </td>
                <td>{item.tel}</td>
                <td
                  style={{
                    maxWidth: "120px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.email}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Stack>
      <div className="d-flex justify-content-end">
        <Link to={"list-volunteers"} className="view-total-list-link">
          {t("dashboard.view_total_list")} <KeyboardArrowRightIcon />
        </Link>
      </div>
    </div>
  );
};

export default VolunteerTable;
